<template>
  <q-modal
    :show="showModal"
    :title="$t('settings.workspaces.assignments_v_2.create')"
    :subtitle="$t('settings.workspaces.assignments.select_type')"
    close-button
    @close="close"
  >
    <div class="grid auto-rows-fr grid-cols-2 gap-4">
      <div>
        <router-link :to="{ name: 'workspace.assignments.agent-qa.new', params: { id } }">
          <button-card
            data-testid="agent-qa-btn"
            tag="button"
            :title="$t('settings.workspaces.assignments.agent_qa.title')"
            :description="$t('settings.workspaces.assignments.conversation_qa.description')"
          />
        </router-link>
      </div>
      <div>
        <div class="h-full">
          <router-link :to="{ name: 'workspace.assignments.reviewer-qa.new', params: { id } }">
            <button-card
              data-testid="reviewer-qa-btn"
              tag="button"
              class="h-full"
              :title="$t('settings.workspaces.assignments.reviewer_qa.title')"
              :description="$t('settings.workspaces.assignments.reviewer_qa.description')"
            />
          </router-link>
        </div>
      </div>
    </div>
    <div class="mt-4 gap-4 text-sm">
      <a
        v-if="session.features.gradeTheReviewerDev"
        class="!flex items-center content-link"
        target="_blank"
        rel="noopener noreferrer"
        :href="$t('support_links.zendesk_help')"
      >
        <help-circle-icon class="mr-2 icon-m" />{{ $t('settings.workspaces.assignments.select_type_help_text') }}
      </a>
    </div>
  </q-modal>
</template>

<script setup lang="ts">
import { HelpCircleIcon } from '@klausapp/ui-kit/icons'
import ButtonCard from '@/modules/workspace/components/ButtonCard.vue'
import { session } from '@/composables/useSession'
import QModal from '@/components/QModal.vue'

defineProps<{
  id: number
  showModal: boolean
}>()

const emit = defineEmits<{
  close: []
}>()

const close = () => {
  emit('close')
}
</script>
